<div style="width: 100%; height: 100%;">
    <div id="panorama"></div>
</div>